/**
 * AmountText (PHASE1 §7.4). Renders a signed Money value with sign colouring
 * (negative → rose, positive → emerald, zero → slate) and tabular figures so
 * columns of amounts align.
 */
import { money } from '../../lib/format.ts';
import type { Money } from '../../lib/types.ts';

export interface AmountTextProps {
  value: Money | number;
  className?: string;
  /** Show an explicit `+` for positive amounts. */
  showPlus?: boolean;
}

export function AmountText({ value, className, showPlus }: AmountTextProps) {
  const n = typeof value === 'number' ? value : Number.parseFloat(value);
  const safe = Number.isFinite(n) ? n : 0;
  const color =
    safe < 0
      ? 'text-rose-600 dark:text-rose-400'
      : safe > 0
        ? 'text-emerald-600 dark:text-emerald-400'
        : 'text-slate-500 dark:text-slate-400';
  const formatted = money(value);
  return (
    <span className={`font-medium tabular-nums ${color} ${className ?? ''}`}>
      {showPlus && safe > 0 ? `+${formatted}` : formatted}
    </span>
  );
}
